import { GeneralPartnerTypeEnum, NavBarBtnModel, UIStatesEnum } from 'common/src/models';
import { ProductTypes } from 'common/src/modules/products/product-types';
import { CreditNotePurposeEnum } from '../../enums';
import { PaymentDirectionEnum } from '../../../payment/models/payment.model';
import { VatRatesFlowEnum } from '../../../shared/enums';
import {
  ControlTypeEnum,
  InputDropdownTypeEnum,
  PositionInfoListModel,
  PositionItemTypeEnum
} from 'common/src/modules/position-card/position-card-models.model';
import { PURPOSES_LIST } from '../../../trade/trade.constants';
import { CORRECTION_POSITION_TYPES_LIST } from '../../../accounting/accounting.constants';
import { PriceOptionEnum } from '../../../shared/enums';

export const ProductTypeTranslateKey = {
  [ProductTypes.GOODS]: 'APP.PRODUCT',
  [ProductTypes.SERVICES]: 'APP.SERVICE',
  [ProductTypes.DIGITAL]: 'APP.DIGITAL_PRODUCT',
  [ProductTypes.BUNDLE]: 'BUNDLES.BUNDLES'
}

export const PositionsButtons: NavBarBtnModel[] = [
  {
    classes: 'btn-white red',
    text: 'BUTTON.REMOVE',
    multipleText: 'BUTTON.REMOVE',
    badgeClass: 'rnpl-badge--grey',
    iconName: 'minus-circle',
    actionName: 'onDeletePositionsClick',
  },
];


export function generatePositionsCardsInfo(
  productType: ProductTypes,
  state: UIStatesEnum,
  crnPurpose: CreditNotePurposeEnum,
  direction: PaymentDirectionEnum,
  vatDisabled: boolean,
  priceOption: PriceOptionEnum,
  smallBusiness: boolean,
  vatIso3: string,
  vatGeneralPartnerType: GeneralPartnerTypeEnum
): PositionInfoListModel[] {
  const cantEditColumn = (state === UIStatesEnum.VIEW);

  let positionInfoList: PositionInfoListModel[] = [
    {
      label: 'FORM.DESCRIPTION',
      prop: 'productDescription',
      isOptional: true,
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXTAREA,
      hideWithProductType: [ProductTypes.SERVICES, ProductTypes.ARBITRARY, ProductTypes.CORRECTION, ProductTypes.OVERDUE_FEE],
      showWithUIState: [UIStatesEnum.EDIT, UIStatesEnum.CREATE],
      showCondition: direction === PaymentDirectionEnum.INCOMING
    },
    {
      label: 'FORM.DESCRIPTION',
      prop: 'providedServices',
      isOptional: true,
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXTAREA,
      hideWithProductType: [
        ProductTypes.GOODS,
        ProductTypes.DIGITAL,
        ProductTypes.BUNDLE,
        ProductTypes.ARBITRARY,
        ProductTypes.CORRECTION,
        ProductTypes.OVERDUE_FEE,
        ProductTypes.PREPAYMENT
      ],
      showWithUIState: [UIStatesEnum.EDIT, UIStatesEnum.CREATE],
      showCondition: direction === PaymentDirectionEnum.INCOMING
    },
    {
      label: 'FORM.DESCRIPTION',
      prop: 'productDescription',
      // isOptional: true,
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXT_EDITOR,
      hideWithProductType: [ProductTypes.SERVICES, ProductTypes.ARBITRARY, ProductTypes.CORRECTION, ProductTypes.OVERDUE_FEE],
      showWithUIState: [UIStatesEnum.EDIT, UIStatesEnum.CREATE],
      showCondition: direction === PaymentDirectionEnum.OUTGOING
    },
    {
      label: 'COLUMN.POSITION_NAME',
      prop: 'description',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXTAREA,
      showWithUIState: [UIStatesEnum.EDIT, UIStatesEnum.CREATE],
      hideWithProductType: [
        ProductTypes.GOODS,
        ProductTypes.DIGITAL,
        ProductTypes.SERVICES,
        ProductTypes.OVERDUE_FEE,
        ProductTypes.PREPAYMENT,
        ProductTypes.ARBITRARY,
      ],
    },
    {
      label: 'FORM.DESCRIPTION',
      prop: 'providedServices',
      // isOptional: true,
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXT_EDITOR,
      hideWithProductType: [
        ProductTypes.GOODS,
        ProductTypes.DIGITAL,
        ProductTypes.BUNDLE,
        ProductTypes.CORRECTION,
        ProductTypes.OVERDUE_FEE,
        ProductTypes.PREPAYMENT
      ],
      showWithUIState: [UIStatesEnum.EDIT, UIStatesEnum.CREATE],
      showCondition: direction === PaymentDirectionEnum.OUTGOING
    },
    {
      label: 'FORM.SPECIFY_AMOUNTS_SEPARATELY',
      prop: 'specifyAmountsSeparately',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TOGGLE,
      itemClass: 'col-12',
      isOptional: true,
      hideWithProductType: [
        ProductTypes.GOODS,
        ProductTypes.SERVICES,
        ProductTypes.DIGITAL,
        ProductTypes.BUNDLE,
        ProductTypes.ARBITRARY,
        ProductTypes.OVERDUE_FEE,
        ProductTypes.PREPAYMENT
      ],
      showWithUIState: [UIStatesEnum.EDIT, UIStatesEnum.CREATE]
    },
    {
      label: 'COLUMN.TYPE',
      prop: cantEditColumn ? 'correctionTypeLabel' : 'correctionType',
      type: cantEditColumn ? PositionItemTypeEnum.PRIMARY : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.DROPDOWN,
      listItems: CORRECTION_POSITION_TYPES_LIST,
      bindLabel: 'label',
      bindValue: 'value',
      disabled: direction === PaymentDirectionEnum.OUTGOING,
      hideWithProductType: [
        ProductTypes.GOODS,
        ProductTypes.SERVICES,
        ProductTypes.DIGITAL,
        ProductTypes.BUNDLE,
        ProductTypes.ARBITRARY,
        ProductTypes.OVERDUE_FEE,
        ProductTypes.PREPAYMENT
      ],
    },
    {
      label: 'COLUMN.INVOICE_QUANTITY',
      prop: 'sourceQuantity',
      unitType: true,
      type: PositionItemTypeEnum.NUMBER,
      showCondition: (state !== UIStatesEnum.VIEW)
        && (crnPurpose === CreditNotePurposeEnum.OIN_CORRECTION || crnPurpose === CreditNotePurposeEnum.IIN_CORRECTION),
      hideWithProductType: [ProductTypes.CORRECTION, ProductTypes.PREPAYMENT],
    },
    {
      label: 'COLUMN.QUANTITY',
      prop: 'quantity',
      unitType: 'unitType',
      type: cantEditColumn ? PositionItemTypeEnum.NUMBER : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.NUMBER,
      hideWithProductType: [ProductTypes.CORRECTION, ProductTypes.PREPAYMENT],
    },
    {
      label: 'COLUMN.UNIT_PRICE_NET',
      prop: 'netUnitPrice',
      suffix: '€',
      type: cantEditColumn ? PositionItemTypeEnum.CURRENCY : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showCondition: (crnPurpose === CreditNotePurposeEnum.COMMON_CORRECTION || crnPurpose === CreditNotePurposeEnum.COMMISSION)
        && (priceOption === PriceOptionEnum.NET || (smallBusiness && direction === PaymentDirectionEnum.OUTGOING)),
      hideWithProductType: [ProductTypes.CORRECTION],
      showUnitOnly: true,
    },
    {
      label: 'COLUMN.UNIT_PRICE_GROSS',
      prop: 'grossUnitPrice',
      suffix: '€',
      type: cantEditColumn ? PositionItemTypeEnum.CURRENCY : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showCondition: (crnPurpose === CreditNotePurposeEnum.COMMON_CORRECTION || crnPurpose === CreditNotePurposeEnum.COMMISSION)
        && (priceOption === PriceOptionEnum.GROSS && !(smallBusiness && direction === PaymentDirectionEnum.OUTGOING)),
      hideWithProductType: [ProductTypes.CORRECTION],
      showUnitOnly: true,
    },
    {
      label: 'COLUMN.INVOICE_AMOUNT_NET',
      prop: 'sourceAmountNet',
      suffix: '€',
      type: PositionItemTypeEnum.CURRENCY,
      showCondition: (state !== UIStatesEnum.VIEW)
        && (priceOption === PriceOptionEnum.NET || (smallBusiness && direction === PaymentDirectionEnum.OUTGOING))
        && (crnPurpose === CreditNotePurposeEnum.OIN_CORRECTION || crnPurpose === CreditNotePurposeEnum.IIN_CORRECTION),
      hideWithProductType: [ProductTypes.CORRECTION],
    },
    {
      label: 'COLUMN.AMOUNT_NET',
      prop: 'netTotalPrice',
      currencyNegativeRow: true,
      suffix: '€',
      type: cantEditColumn ? PositionItemTypeEnum.CURRENCY : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showUnitOnly: true,
      disabled: productType === ProductTypes.PREPAYMENT,
      showCondition: (priceOption === PriceOptionEnum.NET || (smallBusiness && direction === PaymentDirectionEnum.OUTGOING))
        || productType === ProductTypes.CORRECTION
        || productType === ProductTypes.PREPAYMENT
    },
    {
      label: 'COLUMN.VAT',
      prop: 'vat',
      suffix: '%',
      type: PositionItemTypeEnum.PRIMARY,
      // showCondition: crnPurpose === CreditNotePurposeEnum.OIN_CORRECTION || crnPurpose === CreditNotePurposeEnum.IIN_CORRECTION,
      showCondition: productType === ProductTypes.PREPAYMENT,
      // hideWithProductType: [ProductTypes.CORRECTION],
    },
    {
      label: 'COLUMN.VAT',
      prop: 'vat',
      suffix: '%',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.VAT_RATE,
      disabled: true,
      vatBlocked: vatDisabled,
      vatIso3: vatIso3,
      vatGeneralPartnerType,
      vatFlow: direction === PaymentDirectionEnum.INCOMING
        ? VatRatesFlowEnum.INCOMING
        : VatRatesFlowEnum.OUTGOING,
      showCondition: productType === ProductTypes.PREPAYMENT,
    },
    {
      label: 'COLUMN.INVOICE_AMOUNT_GROSS',
      prop: 'sourceAmountGross',
      suffix: '€',
      type: PositionItemTypeEnum.CURRENCY,
      showCondition: (state !== UIStatesEnum.VIEW)
        && (priceOption === PriceOptionEnum.GROSS && !(smallBusiness && direction === PaymentDirectionEnum.OUTGOING) || productType === ProductTypes.PREPAYMENT)
        && (crnPurpose === CreditNotePurposeEnum.OIN_CORRECTION || crnPurpose === CreditNotePurposeEnum.IIN_CORRECTION),
      hideWithProductType: [ProductTypes.CORRECTION],
    },
    // {
    //   label: 'COLUMN.PURPOSE',
    //   prop: 'purposeTranslate',
    //   type: PositionItemTypeEnum.PRIMARY,
    //   showCondition: crnPurpose === CreditNotePurposeEnum.IIN_CORRECTION,
    //   hideWithProductType: [ProductTypes.CORRECTION, ProductTypes.PREPAYMENT],
    // },
    {
      label: 'COLUMN.VAT',
      prop: 'vatTotal',
      suffix: '€',
      type: cantEditColumn ? PositionItemTypeEnum.CURRENCY : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      currencyNegativeRow: true,
      currencySourceFormat: true,
      disabled: vatDisabled,
      vatBlocked: vatDisabled,
      showUnitOnly: true,
      hideWithProductType: [
        ProductTypes.SERVICES,
        ProductTypes.ARBITRARY,
        ProductTypes.GOODS,
        ProductTypes.DIGITAL,
        ProductTypes.BUNDLE,
        ProductTypes.OVERDUE_FEE,
        ProductTypes.PREPAYMENT
      ],
    },
    {
      label: 'COLUMN.AMOUNT_GROSS',
      prop: 'grossTotalPrice',
      currencyNegativeRow: true,
      suffix: '€',
      type: cantEditColumn ? PositionItemTypeEnum.CURRENCY : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      listItems: PURPOSES_LIST,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      valueClass: 'font-weight-500',
      showUnitOnly: true,
      disabled: productType === ProductTypes.PREPAYMENT,
      showCondition: (priceOption === PriceOptionEnum.GROSS && !(smallBusiness && direction === PaymentDirectionEnum.OUTGOING))
        || productType === ProductTypes.CORRECTION
        || productType === ProductTypes.PREPAYMENT
    },
    {
      label: 'COLUMN.VAT',
      prop: 'vat',
      suffix: '%',
      type: cantEditColumn ? PositionItemTypeEnum.PRIMARY : PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.VAT_RATE,
      disabled: vatDisabled,
      vatBlocked: vatDisabled,
      vatIso3: vatIso3,
      vatGeneralPartnerType,
      vatFlow: direction === PaymentDirectionEnum.INCOMING
        ? VatRatesFlowEnum.INCOMING
        : VatRatesFlowEnum.OUTGOING,
      showCondition: (crnPurpose === CreditNotePurposeEnum.COMMON_CORRECTION || crnPurpose === CreditNotePurposeEnum.COMMISSION)
        && direction === PaymentDirectionEnum.INCOMING,
      hideWithProductType: [ProductTypes.CORRECTION],
    },
  ];

  return positionInfoList
    .filter(itm => !itm.hasOwnProperty('showCondition') || itm.showCondition)
    .filter(itm => !itm.hasOwnProperty('hideWithProductType') || !itm.hideWithProductType.includes(productType))
    .filter(itm => !itm.hasOwnProperty('showWithUIState') || itm.showWithUIState.includes(state));
}

export function generatePositionsCardsInfoArbitrary(
  priceOption: PriceOptionEnum,
  smallBusiness: boolean
): PositionInfoListModel[] {
  return [
    {
      label: 'FORM.DESCRIPTION',
      prop: 'providedServices',
      // isOptional: true,
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXT_EDITOR,
    },
    {
      label: 'COLUMN.QUANTITY',
      prop: 'quantity',
      unitType: 'unitType',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.NUMBER,
    },
    {
      label: 'COLUMN.AMOUNT_NET',
      prop: 'netTotalPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      valueClass: 'font-weight-500',
      showUnitOnly: true,
      showCondition: (priceOption === PriceOptionEnum.NET) || smallBusiness
    },
    {
      label: 'COLUMN.AMOUNT_GROSS',
      prop: 'grossTotalPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      valueClass: 'font-weight-500',
      showUnitOnly: true,
      showCondition: (priceOption === PriceOptionEnum.GROSS) && !smallBusiness
    },
  ].filter((itm: PositionInfoListModel) => !itm.hasOwnProperty('showCondition') || itm.showCondition);
}

export function topBlockControls(
  productType: ProductTypes,
  crnPurpose: CreditNotePurposeEnum,
  direction: PaymentDirectionEnum,
  priceOption: PriceOptionEnum,
  smallBusiness: boolean,
  vatDisabled: boolean
): PositionInfoListModel[] {

  let positionInfoList: PositionInfoListModel[] = [
    {
      label: 'COLUMN.UNIT_PRICE_NET',
      prop: 'netUnitPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showCondition: (crnPurpose === CreditNotePurposeEnum.COMMON_CORRECTION || crnPurpose === CreditNotePurposeEnum.COMMISSION)
        && (priceOption === PriceOptionEnum.GROSS) && !(smallBusiness && direction === PaymentDirectionEnum.OUTGOING),
      hideWithProductType: [ProductTypes.CORRECTION],
      showUnitOnly: true,
    },
    {
      label: 'COLUMN.AMOUNT_NET',
      prop: 'netTotalPrice',
      currencyNegativeRow: true,
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showUnitOnly: true,
      disabled: productType === ProductTypes.PREPAYMENT,
      showCondition: (priceOption === PriceOptionEnum.GROSS) && !(smallBusiness && direction === PaymentDirectionEnum.OUTGOING),
      hideWithProductType: [ProductTypes.PREPAYMENT],
    },
    {
      label: 'COLUMN.UNIT_PRICE_GROSS',
      prop: 'grossUnitPrice',
      suffix: '€',
      disabled: vatDisabled,
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showCondition: (crnPurpose === CreditNotePurposeEnum.COMMON_CORRECTION || crnPurpose === CreditNotePurposeEnum.COMMISSION)
        && (priceOption === PriceOptionEnum.NET && !(smallBusiness && direction === PaymentDirectionEnum.OUTGOING)),
      hideWithProductType: [ProductTypes.CORRECTION],
      showUnitOnly: true,
    },
    {
      label: 'COLUMN.AMOUNT_GROSS',
      prop: 'grossTotalPrice',
      currencyNegativeRow: true,
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      listItems: PURPOSES_LIST,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showUnitOnly: true,
      disabled: productType === ProductTypes.PREPAYMENT || vatDisabled,
      showCondition: (priceOption === PriceOptionEnum.NET && !(smallBusiness && direction === PaymentDirectionEnum.OUTGOING)),
      hideWithProductType: [ProductTypes.PREPAYMENT, ProductTypes.CORRECTION],
    },
  ];

  return positionInfoList
    .filter(itm => {
      if (itm.hasOwnProperty('showCondition')) {
        return itm.showCondition;
      }
      return true;
    })
    .filter((col: PositionInfoListModel) => {
      if (col.hideWithProductType) {
        return !col.hideWithProductType.includes(productType);
      }
      return true;
    });
}
